var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTextField',_vm._b({attrs:{"value":_vm.search,"icon-right":_vm.icon,"dense":""},on:{"update":_vm.updateSearch,"iconRightClicked":_vm.iconClicked,"keyup":_vm.keyupField}},'BaseTextField',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }